import Vue from 'vue'
import Router from 'vue-router'
import {userService} from '@/store/auth-header.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    }, {
      path: '/ledgergroup',
      name: 'ledgergroup',
      component: () => import('./views/account/ledgergroup/LedgerGroupView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/ledger',
      name: 'ledger',
      component: () => import('./views/account/ledger/LedgerView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newcontra',
      name: 'newcontra',
      component: () => import('./views/account/contra/ContraForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/opencontra',
      name: 'opencontra',
      component: () => import('./views/account/contra/ContraView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/supplier',
      name: 'supplier',
      component: () => import('@/views/xpos/supplier/SupplierView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/buyer',
      name: 'buyer',
      component: () => import('@/views/xpos/buyer/BuyerView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/item',
      name: 'item',
      component: () => import('./views/xpos/item/ItemView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/itemgroup',
      name: 'itemgroup',
      component: () => import('./views/xpos/itemgroup/ItemGroupView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/settlement',
      name: 'settlement',
      component: () => import('@/views/xpos/bills/CouponView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/bills',
      name: 'bills',
      component: () => import('@/views/xpos/bills/BillView.vue'),
      beforeEnter (to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      //digitalbills
      path: '/digitalbills',
      name: 'digitalbills',
      component: () => import('@/views/xpos/bills/DigitalBillView.vue'),
      beforeEnter (to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/priceupdate',
      name: 'priceupdate',
      component: () => import('@/views/xpos/priceupdate/PriceUpdateForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newinvoice',
      name: 'newinvoice',
      component: () => import('@/views/xpos/purchase/PurchaseForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/openinvoice',
      name: 'openinvoice',
      component: () => import('@/views/xpos/purchase/PurchaseView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/newfuelinvoice',
      name: 'newfuelinvoice',
      component: () => import('@/views/xpos/fuelpurchase/FuelPurchaseForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/openfuelinvoice',
      name: 'openfuelinvoice',
      component: () => import('@/views/xpos/fuelpurchase/FuelPurchaseView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newsaleinvoice',
      name: 'newsaleinvoice',
      component: () => import('@/views/xpos/sale/SaleInvoiceForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/opensaleinvoice',
      name: 'opensaleinvoice',
      component: () => import('@/views/xpos/sale/SaleInvoiceView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newsalereceipt',
      name: 'newsalereceipt',
      component: () => import('@/views/xpos/sale/SaleReceipt.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/opensalereceipt',
      name: 'opensalereceipt',
      component: () => import('@/views/xpos/sale/SaleReceiptView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newtransfer',
      name: 'newtransfer',
      component: () => import('@/views/xpos/transfer/TransferForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newhopayment',
      name: 'newhopayment',
      component: () => import('@/views/xpos/hopayment/HoPaymentForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/openhopayment',
      name: 'openhopayment',
      component: () => import('@/views/xpos/hopayment/HoPaymentView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newtesting',
      name: 'newtesting',
      component: () => import('@/views/xpos/testentry/TestEntryForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/opentesting',
      name: 'opentesting',
      component: () => import('@/views/xpos/testentry/TestEntryView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newvaultpayment',
      name: 'newvaultpayment',
      component: () => import('@/views/xpos/vaultpayment/VaultPaymentForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/openvaultpayment',
      name: 'openvaultpayment',
      component: () => import('@/views/xpos/vaultpayment/VaultPaymentView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/newvaultreceipt',
      name: 'newvaultreceipt',
      component: () => import('@/views/xpos/vaultreceipt/VaultReceiptForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/openvaultreceipt',
      name: 'openvaultreceipt',
      component: () => import('@/views/xpos/vaultreceipt/VaultReceiptView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/newadjustment',
      name: 'newadjustment',
      component: () => import('@/views/xpos/stockadjust/StockAdjustForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/openadjustment',
      name: 'openadjustment',
      component: () => import('@/views/xpos/stockadjust/StockAdjustView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
      //newmeterreading
    }, {
      path: '/newmeterreading',
      name: 'newmeterreading',
      component: () => import('@/views/xpos/meterreading/MeterReadingForm.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/openmeterreading',
      name: 'openmeterreading',
      component: () => import('@/views/xpos/meterreading/MeterReadingView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/terminal',
      name: 'terminal',
      component: () => import('@/views/xpos/terminal/TerminalView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/cashier',
      name: 'cashier',
      component: () => import('@/views/xpos/cashier/CashierView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/saleman',
      name: 'saleman',
      component: () => import('@/views/xpos/salesman/SalesManView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      //dipchart
      path: '/dipchart',
      name: 'dipchart',
      component: () => import('@/views/xpos/dipchart/DipChartView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/outlet',
      name: 'outlet',
      component: () => import('@/views/xpos/outlet/OutletView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/tank',
      name: 'tank',
      component: () => import('@/views/xpos/tank/TankView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/vehicle',
      name: 'vehicle',
      component: () => import('@/views/xpos/vehicle/VehicleView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/vehiclecategory',
      name: 'vehiclecategory',
      component: () => import('@/views/xpos/vehiclecateogry/VehicleCategoryView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/nozzle',
      name: 'nozzle',
      component: () => import('@/views/xpos/nozzle/NozzleView.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    },{
      path: '/posbills',
      name: 'posbills',
      component: () => import('@/views/reports/xpos/posbills.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/actualvsportal',
      name: 'actualvsportal',
      component: () => import('@/views/gst/actualvsportal/ActualvsPortal.vue'),
      beforeEnter(to, from, next) {
        userService.routeProtecter(to, from, next);
      }
    }, {
      path: '/form-designer',
      name: 'form-designer',
      component: () => import('@/views/tools/designer/DesignerView.vue')
    }, {
      path: '/gen-settings',
      name: 'Settings',
      component: () => import('@/views/tools/general/SettingsView.vue')
    }

  ]
})
